module.exports = __webpack_public_path__ + "img/28.99daa426.png";